module.exports = __webpack_public_path__ + "img/URBANSOLAR.60472ee0.png";